module.exports = __webpack_public_path__ + "img/danrley.d5921734.jpeg";